// ABOUTME: Picks the tenant's display label of the market concept for the current locale.
// ABOUTME: Falls back from the full locale to its language prefix, then to the react-intl default.

/**
 * `label[locale]`, else `label[language prefix]`, else `fallback`. Blank entries are ignored.
 */
export const resolveMarketLabel = (
    label: Record<string, string> | null | undefined,
    locale: string,
    fallback: string,
): string => {
    const language = locale.split('-')[0];
    const candidates = [label?.[locale], label?.[language]];
    return candidates.find(value => !!value?.trim()) ?? fallback;
};

/** The label as used inside a sentence ("Switch the active market"). */
export const toSentenceLabel = (label: string, locale: string): string => {
    try {
        return label.toLocaleLowerCase(locale);
    } catch {
        return label.toLowerCase();
    }
};
